module.exports = __webpack_public_path__ + "img/people_search.f3536010.svg";